var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-container"},_vm._l((_vm.messages),function(message,index){return _c('b-alert',{key:index,attrs:{"show":"","fade":"","dismissible":"","variant":message.type}},[_c('span',{domProps:{"innerHTML":_vm._s(message.text)},on:{"click":function($event){return _vm.handleClick(message)}}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }